// What the Create Deal form keeps in the browser draft (Trac #1104, step 1).
//
// Field values only. Photos are files and can be large, so they are counted,
// never stored. Payout details (PayPal email, bank account name, number and
// sort code) stay out too: payout details never go to browser storage.

export const CREATE_DEAL_DRAFT_VERSION = 1

export function createDealDraftKey(userId) {
  return userId == null ? null : `prism:create-deal-draft:${userId}`
}

// The searched-for stock item carries a whole product record. The form reads
// only these fields from it.
function slimStockItem(item) {
  if (!item) return null
  const { id, shopify_id, title, sku, price, quantity } = item
  return { id, shopify_id, title, sku, price, quantity, images: item.images?.[0]?.src ? [{ src: item.images[0].src }] : [] }
}

export function toDraftState(fields) {
  const { items, selectedPxItem, paypalEmail, bankName, bankAccount, bankSort, ...kept } = fields
  return {
    ...kept,
    items: items.map(({ photos, ...values }) => values),
    selectedPxItem: slimStockItem(selectedPxItem),
    photoCount: items.reduce((total, item) => total + (item.photos?.length || 0), 0),
  }
}
